var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.071 3.667H2.93v13.3c0 .35.287.633.642.633H16.43a.638.638 0 00.642-.633v-13.3zM1 1.767v15.2C1 18.366 2.151 19.5 3.571 19.5H16.43c1.42 0 2.571-1.134 2.571-2.533v-15.2H1z",
    fill: "#ff7f27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.179 5.567V.5h1.928v5.067H5.18zM9.036 13.167V8.1h1.928v5.067H9.036z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.571 11.583H7.43v-1.9h5.142v1.9zM12.893 5.567V.5h1.928v5.067h-1.928z"
  })));
}

export default SvgActivity;